module.exports = __webpack_public_path__ + "img/Septris-sprite-start-old.f37d04b6.png";